var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "body" }, [
    _c("span", { staticClass: "description" }, [
      _vm._v("\n    Detalhes da limpeza\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "body-content" }, [
      _c("div", { staticClass: "date" }, [
        _c("img", { attrs: { src: "/static/calendar-outlined.svg" } }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm._f("getOrderScheduleDay")(_vm.order)))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "duration" }, [
        _c("img", { attrs: { src: "/static/clock-outlined.svg" } }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm._f("getOrderDuration")(_vm.order)))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "location" }, [
        _c("img", { attrs: { src: "/static/pin.svg" } }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm._f("getOrderAddressName")(_vm.order)))])
      ])
    ]),
    _vm._v(" "),
    _vm.isProvisioning
      ? _c(
          "div",
          { staticClass: "order-countdown" },
          [
            _c("ProgressBar", {
              attrs: { progress: _vm.percentageTimeCompleted() }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "progress-text" }, [
              _c("div", { staticClass: "starting" }, [
                _c("span", [_vm._v("iniciado às")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatDate")(
                        _vm.order.updated_at,
                        "DD/MM HH:mm:ss"
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ending" }, [
                _c("span", [_vm._v("término estimado")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatDate")(_vm.endingAt(), "DD/MM HH:mm:ss")
                    )
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(0)
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.orderNotInitialized
      ? _c("div", { staticClass: "alert-message" }, [
          _c("img", {
            attrs: { src: "/static/exclamation-triangle-solid.svg" }
          }),
          _vm._v(
            "\n\n    Entre em contato com o nosso suporte caso a limpeza não tenha sido realizada.\n  "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert-message" }, [
      _c("img", { attrs: { src: "/static/exclamation-triangle-solid.svg" } }),
      _vm._v(
        "\n\n        Os horários mostrados aqui podem variar de acordo com a hora em que limpeza foi iniciada pelo profissional.\n      "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e30cb79", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e30cb79","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/Components/Card/Body.vue
// module id = null
// module chunks = 